﻿import { apiBaseUrl } from 'config/config';

export const TYPES = {
  general: 'general',
  consult: 'consult',
  task: 'task',
};

export const url = ({ id }) => `${apiBaseUrl}notes/${id}/`;
